function showacc() {    
  $('.accountdiv').toggle('');  
} 

function shows(para) {
  if($(window).width() <= 767 ) {
    $('#tabs'+para).slideToggle('1000');
    //$('#q'+para +' '+'i').toggleClass("ion-android-remove");

    if($('#q'+para +' '+'i').hasClass("fa-angle-down")){
      $('#q'+para +' '+'i').addClass("fa-angle-up");
      $('#q'+para +' '+'i').removeClass("fa-angle-down");
    } else {
      $('#q'+para +' '+'i').addClass("fa-angle-down");
      $('#q'+para +' '+'i').removeClass("fa-angle-up");
    }
  }
}

$('.slider').slick({
  dots: true,
  infinite: true,
  autoplay: true,
  arrows:false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [{
    breakpoint: 1024,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
    }
  }, {
    breakpoint: 768,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows:false   
    }
  }, {
    breakpoint: 480,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows:false,
    }
  }]
});

$('.best_seller_slider').slick({
  dots: false,
  infinite: true,
  arrows:false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [{
    breakpoint: 1024,
    settings: {
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      arrows:false,
    }
  }, {
    breakpoint: 768,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows:true,
      dots: false,
    }
  }, {
    breakpoint: 480,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows:true,
      dots: false,
    }
  }]
});

$('.mobile_slider').slick({
  dots: false,
  infinite: true,
  arrows:false,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [{
    breakpoint: 1024,
    settings: {
      slidesToShow: 3 ,
      slidesToScroll: 1,
      dots: false,
    }
  }, {
    breakpoint: 768,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows:false,
      dots: false,
    }
  }, {
    breakpoint: 480,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows:false,
      dots: false,
    }
  }]
});

$(document).ready( function() {
  $(window).scroll(function() {        
    if($(window).scrollTop() < 100) {
      
      $(".banner--clone").removeClass('banner--stick');    
      $(".header_menu").removeClass('header--stick'); 
      $("#bodytop").css({'padding-top': '0px'});       
      
    } else {             
      
      $(".banner--clone").addClass('banner--stick');
      $(".header_menu").addClass('header--stick').css({ top: jQuery('.banner--clone').height() }); 
      $("#bodytop").css({'padding-top': jQuery('.banner--clone').outerHeight() + jQuery('.header_menu').outerHeight() });      
      
    }
  });

  jQuery(window).on('resize', function(){
    if($(window).scrollTop() < 1) {
      $(".banner--clone").removeClass('banner--stick');    
      $("#bodytop").css({'padding-top': '0px'});                        
    } else {             
       $(".header_menu").addClass('header--stick').css({ top: jQuery('.banner--clone').height() }); 
      $(".banner--clone").addClass('banner--stick');
      $("#bodytop").css({'padding-top': jQuery('.banner--clone').outerHeight()+20});                        
    }
  });
});

/*
(function ($) {
  "use strict";
  $(".cart-plus-minus").append('<div class="dec qtybutton"><i class="fa fa-angle-down"></i></div><div class="inc qtybutton"><i class="fa fa-angle-up"></i></div>');
  $(".qtybutton").on("click", function() {
    var $button = $(this);
    var oldValue = $button.parent().find("input").val();
    if ($button.hasClass('inc')) {
      var newVal = parseFloat(oldValue) + 1;
    } else {
      // Don't allow decrementing below zero
      if (oldValue > 0) {
        var newVal = parseFloat(oldValue) - 1;
      } else {
        newVal = 0;
      }
    }
    $button.parent().find("input").val(newVal);
  }); 

  // Single Product Sticky Sidebar
  var windowWidth = $(window).width();
  if (992 <= windowWidth) {
    $('.sidebar-active').stickySidebar({
      topSpacing: 80,
      bottomSpacing: 30,
      minWidth: 767
    });
  }
})(jQuery);
*/
/* These are the modifications to look for location change for the mutation obserever. */
history.pushState = ( f => function pushState(){
    var ret = f.apply(this, arguments);
    window.dispatchEvent(new Event('pushstate'));
    window.dispatchEvent(new Event('locationchange'));
    return ret;
})(history.pushState);

history.replaceState = ( f => function replaceState(){
    var ret = f.apply(this, arguments);
    window.dispatchEvent(new Event('replacestate'));
    window.dispatchEvent(new Event('locationchange'));
    return ret;
})(history.replaceState);

window.addEventListener('popstate',()=>{
    window.dispatchEvent(new Event('locationchange'))
});

//Callback that runs once the observer has found the correct elemements.
function ammendPrice(items){
  	  console.log(items);
  //Loop through the HTMLCollection of all the elements on the page.
  for (let i = 0; i < items.length; i++) {
     var item = $(items[i])
      //console.log(item);
    	var comparePrice = item.find('.snize-price-with-discount');
    	//console.log(comparePrice);
    	comparePrice.detach().appendTo(item.find('.snize-price-list')); 
  }
  

}


// set up the mutation observer
var observer = new MutationObserver(function (mutations, me) {
  // `mutations` is an array of mutations that occurred
  // `me` is the MutationObserver instance
  var items = document.getElementsByClassName('snize-item');
  if (items.length > 0) {
    ammendPrice(items);
    me.disconnect(); // stop observing
    return;
  }
});

// start the observer and make sure it looks deep.
observer.observe(document, {
  childList: true,
  subtree: true
});

$(window).bind('locationchange', function(){

  console.log('click')
  console.log(observer)
  //When the pagniation is click, run the observer again.
  observer.observe(document, {
    childList: true,
    subtree: true
  });

});